import { useI18n } from '../i18n';
import type { BookingProfileAuthBlockReason } from '../utils/bookingProfileGateAuthError';
import styles from './ProfileCompletionSheet.module.css';

type ProfileBookingAuthBlockPanelProps = {
  reason: BookingProfileAuthBlockReason;
  onDismiss: () => void;
  onSignInAgain: () => void;
};

export function ProfileBookingAuthBlockPanel({
  reason,
  onDismiss,
  onSignInAgain,
}: ProfileBookingAuthBlockPanelProps) {
  const { t } = useI18n();
  const bodyKey =
    reason === 'ipMismatch'
      ? 'bookings.error.profileAuth.ipMismatch'
      : 'bookings.error.profileAuth.session';

  return (
    <>
      <p className={styles.intro}>{t(bodyKey)}</p>
      <div className={styles.actions}>
        <button type="button" className={styles.primaryButton} onClick={onSignInAgain}>
          {t('bookings.error.profileAuth.signInAgain')}
        </button>
        <button type="button" className={styles.secondaryButton} onClick={onDismiss}>
          {t('common.close')}
        </button>
      </div>
    </>
  );
}
